/**
 * Shared site copy.
 *
 * The headline and tagline now live in the message catalogs as `site.headline`
 * and `site.tagline`, because they are the most-seen strings on the site - the
 * homepage <title>, og:title, the hero subtitle and the footer - and leaving
 * them here would have kept them English in eleven languages.
 *
 * The constants stay as the English source of record, and `gatsby-config.js`
 * still carries a synced copy for `siteMetadata` (CJS cannot import this
 * module). Read them through `t("site.headline")` / `t("site.tagline")`, or
 * from the catalog directly inside a Head export - never render these
 * constants into the page.
 */
export const SITE_HEADLINE = "Your own team of AI agents. Built to deliver.";

export const SITE_TAGLINE =
  "Hezo lets you create and manage teams of AI agents to get real work done.";

export const GITHUB_URL = "https://github.com/hezo-ai/hezo";
